<template>
  <div class="animated fadeIn">
    <h3>Septic Soil Report</h3>
    <b-card no-body>
      <b-card-header>
        <span class="text-muted text-uppercase">
          Tissue report data
        </span>
      </b-card-header>
      <b-card-body class="p-0">
        <b-table
          :items="report_samples"
          :fields="columns"
          class="mb-0"
          responsive
          bordered
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "SubmissionSepticReport",
  props: {
    samples: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    columns() {
      return [
        { key: "number", label: "Sample ID" },
        { key: "id", label: "Cust. Sample ID" },
        { key: "depth", label: "Depth" },
        ...this.samples[0].analytes.map(({ name, unit }) => {
          return {
            key: name,
            label: `${name} ${unit} (d.limit)`
          }
        })
      ]
    },
    report_samples() {
      return this.samples.map(({ number, id, depth, analytes }) => {
        return {
          number,
          id,
          depth,
          ...analytes.reduce((acc, cur) => {
            return {
              ...acc,
              [cur.name]: `${cur.value} (${cur.detect_limit})`
            }
          }, {})
        }
      })
    }
  }
}
</script>